import { Injectable } from '@angular/core';
import { MonthDatePickerComponent } from './month-date-picker.component';

/**
 * A service that represents the keyboard navigation.
 *
 * Default keyboard shortcuts [are documented in the overview](#/components/datepicker/overview#keyboard-shortcuts)
 *
 * @since 5.2.0
 */

@Injectable({ providedIn: 'root' })
export class NgbMonthDatepickerKeyboardService {
  /**
   * Processes a keyboard event.
   */
  processKey(event: KeyboardEvent, cal: MonthDatePickerComponent) {
    const cells = cal.cells.toArray();
    let index = cal.isyear
      ? cells.findIndex((x) => x.nativeElement.dataset.year == cal.displayYear)
      : cells.findIndex((x) => x.nativeElement.dataset.month == cal.displayMonth);

    if (index < 0) return;
    switch (event.key) {
      case 'ArrowDown':
        if (cal.isyear) {
          if (index > 8) cal.setValues(cal.initialYear + 12, cal.displayYear + 3, cal.displayMonth);
          else cal.setValues(cal.initialYear, cal.displayYear + 3, cal.displayMonth);
        } else {
          if (index > 8) {
            cal.setValues(cal.initialYear, cal.displayYear + 1, ((cal.displayMonth + 2) % 12) + 1);
          } else cal.setValues(cal.initialYear, cal.displayYear, ((cal.displayMonth + 2) % 12) + 1);
        }
        cal.focus();

        break;
      case 'ArrowUp':
        if (cal.isyear) {
          if (index < 3) cal.setValues(cal.initialYear - 12, cal.displayYear - 3, cal.displayMonth);
          else cal.setValues(cal.initialYear, cal.displayYear - 3, cal.displayMonth);
        } else {
          if (index < 3) cal.setValues(cal.initialYear, cal.displayYear - 1, ((cal.displayMonth + 8) % 12) + 1);
          else cal.setValues(cal.initialYear, cal.displayYear, ((cal.displayMonth + 8) % 12) + 1);
        }
        cal.focus();
        break;
      case 'ArrowLeft':
        if (cal.isyear) {
          if (index == 0) cal.setValues(cal.initialYear - 12, cal.displayYear - 1, cal.displayMonth);
          else cal.setValues(cal.initialYear, cal.displayYear - 1, cal.displayMonth);
        } else {
          if (index == 0) {
            cal.setValues(cal.initialYear, cal.displayYear - 1, 12);
          } else cal.setValues(cal.initialYear, cal.displayYear, cal.displayMonth - 1);
        }

        cal.focus();
        break;
      case 'ArrowRight':
        if (index == 11) {
          if (cal.isyear) cal.setValues(cal.initialYear + 12, cal.displayYear + 1, cal.displayMonth);
          else cal.setValues(cal.initialYear, cal.displayYear + 1, 1);
        } else {
          if (cal.isyear) cal.setValues(cal.initialYear, cal.displayYear + 1, cal.displayMonth);
          else cal.setValues(cal.initialYear, cal.displayYear, cal.displayMonth + 1);
        }
        cal.focus();
        break;
      case 'PageDown':
        cal.displayYear++;
        break;
      case 'PageUp':
        cal.displayYear--;
        break;
      case 'Enter':
        cal.selectYearMonth(index);
        break;

      case 'Tab':
        const bt = cal.buttons.find((x) => x.nativeElement.getAttribute('disabled') == null);
        if (bt) bt.nativeElement.focus();
        break;
      case 'Escape':
        if (cal.isyear) {
          cal.displayYear = cal.displayYearOld;
          cal.isyear = false;
          cal.focus();
        } else return;
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  }
}
